import { ArticleAuthor } from 'stores/ArticleStoreAdapter';

/** readTime 換算係数（文字/分）。日本語の平均読書速度からの暫定値。 */
const CHARS_PER_MINUTE = 500;

/** グループ化表示（Author ごと / Labels ごと）の各グループの初期表示上限（フロント定数） */
export const GROUP_DISPLAY_LIMIT = 6;

/** readTime の表示単位（分）。この単位で切り捨てる。 */
const READ_TIME_STEP_MINUTES = 5;

/**
 * 本文文字数から readTime 表示文字列を算出する。
 * charCount が null / 0 以下のときは表示しない（undefined を返す）。
 * 分は READ_TIME_STEP_MINUTES（5分）単位で切り捨てる。ただし最低 5 分は表示する
 * （5 分未満で 0 分にならないようにするため）。
 */
export const formatReadTime = (charCount: number | null): string | undefined => {
  if (charCount === null || charCount <= 0) return undefined;
  const rawMinutes = charCount / CHARS_PER_MINUTE;
  const minutes = Math.max(
    READ_TIME_STEP_MINUTES,
    Math.floor(rawMinutes / READ_TIME_STEP_MINUTES) * READ_TIME_STEP_MINUTES,
  );
  return `${minutes} min read`;
};

/** 著者一覧を「、」区切りの表示名文字列に整形する。 */
export const formatAuthors = (authors: ArticleAuthor[]): string =>
  authors.map((a) => a.userName).join('、');
